import { axiosBase, errorHandler } from './axios';

const uploadSelfie = (formData: any, onUploadProgress?: (progressEvent: any) => void) => {
  return axiosBase.post('/api/v1/events/attendance/upload', formData, {
    onUploadProgress,
  })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const markAttendanceByUrl = (payload: { eventId: string; imageUrl: string; latitude: string; longitude: string }) => {
  return axiosBase.post('/api/v1/events/attendance/mark', payload)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getEventAttendance = (eventId: string) => {
  return axiosBase.get(`/api/v1/events/attendance/event/${eventId}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const deleteTempImage = (eventId: string) => {
  return axiosBase.delete('/api/v1/events/attendance/temp-image', {
    data: { eventId },
  })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const attendanceService = { 
  uploadSelfie, 
  markAttendanceByUrl, 
  getEventAttendance,
  deleteTempImage
};
